const apiUrl = process.env.REACT_APP_API_URL;

const getAssetTypes = (token, cb) => {
    fetch(`${apiUrl}/assettypes`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
        }
    })
        .then(res => res.json())
        .then(res => {
            cb(res);
        });
};

export default getAssetTypes;
